import { styled } from 'styled-components';

import { mq, rowYMiddle } from '@/shared/ui/styled';

export const StyledProductTitleContainer = styled.div`
    padding-bottom: 16px;

    h1 {
        word-break: break-word;
    }

    ${mq.gt.sm} {
        padding-bottom: 21px;
    }
`;

export const StyledProductTitleRow = styled.div`
    ${rowYMiddle}

    svg {
        margin-top: 5px;
    }
`;

export const StyledParagraph = styled.p`
    font-weight: 500;
    font-size: 12px;
    line-height: 15.6px;
`;

export const StyledStatusParagraph = styled(StyledParagraph)`
    font-size: ${({ theme }) => theme.fontSize.sm};
    margin: 12px 0 8px 8px;
`;

export const StyledAddressParagraph = styled(StyledParagraph)`
    font-size: ${({ theme }) => theme.fontSize.sm};
    color: ${({ theme }) => theme.color.primary};

    ${mq.lt.sm} {
        font-size: ${({ theme }) => theme.fontSize.xs};
    }
`;
